import React, { useCallback, useEffect, useState } from 'react'
import HeaderCard from '../../../component/cardCustom/headerCard';
import { Box, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import InputTextField from '../../../component/input/inputTextField';
import { getBranch, handleTypingNumber } from '../../../utils/app.utils';
import TableCustom from '../../../component/table/tableCustom';
import TableRowCommon from '../../../component/table/TableRowCommon';
import StallsListApi from '../../../api/stalls-list/stalls-list.api';
import { colors } from '../../../constants/colors';
import { faEye, faFilePen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHistory } from 'react-router-dom';
import { routeName } from '../../../routes/routers-name';
import ButtonCustom from '../../../component/button/buttonCustom';
import ModalCustom from '../../../component/modalCustom/modalCustom';
import { useDispatch } from 'react-redux';
import { closeModal, showModal } from '../../../app/slice/modal.slice';
import { notiError, notiSuccess } from '../../../component/notification/notifications';

export default function ZoneManage() {
    const { t } = useTranslation();
    const history = useHistory();
    const dispatch = useDispatch();
    const [form, setForm] = useState<any>()
    const [errorMessage, setErrorMessage] = useState<any>();
    const clearErrorMessage = () => setErrorMessage({});

    const [page, setPage] = useState<number>(1)
    const [pageLimit, setPageLimit] = useState<number>(25)
    const [search, setSearch] = useState<string>("");
    const [modalType, setModalType] = useState<string>("");
    const [rowCount, setRowCount] = useState<number>();
    const [zoneData, setZoneData] = useState<any[]>([]);

    const branchId: number = Number(getBranch() || 1);
    const loadDataStall = useCallback(async () => {
        let condition: any = {
            page: page,
            limit: pageLimit,
            keyword: search || "",
            branchId,

        }

        const res = await StallsListApi.zoneList(condition)

        if (res.status === 200) {
            setZoneData(res.data.data.items)
            setRowCount(res.data.data.meta?.totalItems)

        } else {
            setZoneData([])
        }
    }, [page, pageLimit, search])

    useEffect(() => {
        loadDataStall()
    }, [loadDataStall])

    const getZone = async (id: any) => {

        const res = await StallsListApi.findZoneById(id)

        if (res.status === 200) {
            setForm(res.data.data)
            dispatch(showModal())
            setModalType("ADD")
            // setRowCount(res.data.data.meta?.totalItems)

        }
    }
    const headCells = [
        { id: "no", disablePadding: false, label: 'ชื่อโซน' },
        { id: "date", disablePadding: false, align: 'center', label: t("จำนวนแผงค้าที่ว่าง") },
        { id: "zoneName", disablePadding: false, align: 'center', label: t("จำนวนแผงค้าทั้งหมด") },
        { id: "stall", disablePadding: false, align: 'center', label: t("จำนวนแผงค้าที่เปิดให้จอง") },
        { id: "stall", disablePadding: false, align: 'center', label: t("จำนวนแผงค้าที่ทำสัญญาแล้ว") },
        { id: "stallType", disablePadding: false, align: 'center', label: t("จำนวนแผงค้าที่ข้อมูลไม่ครบ") },
        { id: "action", disablePadding: false, align: 'center', label: t("") },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1

        const { zoneId, zoneName, count_all, count_blank, count_open, count_non_info, count_contract } =
            objData;

        const objRenderData = {
            key: zoneId,
            id: zoneId,
            obj: objData,
            columns: [
                { option: "TEXT", align: "left", label: zoneName },
                { option: "TEXT", align: "center", label: count_blank || "-" },
                { option: "TEXT", align: "center", label: count_all || "-" },
                { option: "TEXT", align: "center", label: count_open || "-" },
                { option: "TEXT", align: "center", label: count_contract || "-" },
                { option: "TEXT", align: "center", label: count_non_info || "-" },
                {
                    option: "COMPONENT",
                    align: "center",
                    component: (
                        <div className="d-flex align-items-center justify-content-center mx-auto w-100">

                            <Tooltip title="ดู">
                                <IconButton onClick={() => { history.push(routeName.stallManage + '/' + zoneId) }}>
                                    <FontAwesomeIcon
                                        icon={faEye}
                                        style={{
                                            fontSize: "20px",
                                            width: "22px",
                                            color: colors.themeMainColor
                                        }}
                                    />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="แก้ไข">
                                <IconButton onClick={() => {

                                    // setForm(objData)
                                    getZone(zoneId)
                                }}>
                                    <FontAwesomeIcon
                                        icon={faFilePen}
                                        style={{
                                            fontSize: "20px",
                                            width: "22px",
                                            color: colors.themeMainColor
                                        }}
                                    />
                                </IconButton>
                            </Tooltip>

                        </div>
                    ),
                },


            ],
        };
        return (<TableRowCommon {...objRenderData} />
        )
    };

    const handleSubmit = async () => {
        const body = {
            ...form,
            branchId: branchId,
            status: "ACTIVE"
        }
        if (!form?.zoneName)
            return setErrorMessage({
                ...errorMessage,
                ...{ zoneName: 'ระบุชื่อโซน' },
            });
        if (!form?.width)
            return setErrorMessage({
                ...errorMessage,
                ...{ width: 'ระบุชื่อความกว้าง' },
            });
        if (!form?.height)
            return setErrorMessage({
                ...errorMessage,
                ...{ height: 'ระบุชื่อความยาว' },
            });
        if (!form?.realWidth)
            return setErrorMessage({
                ...errorMessage,
                ...{ realWidth: 'ระบุชื่อความกว้าง' },
            });
        if (!form?.realHeight)
            return setErrorMessage({
                ...errorMessage,
                ...{ realHeight: 'ระบุชื่อความยาว' },
            });

        if (form?.zoneId) {
            const res = await StallsListApi.updateZone(body, form?.zoneId)
                .then(res => {
                    if (res.status === 200) {
                        notiSuccess(t('บันทึกโซนสำเร็จ'))
                        dispatch(closeModal())
                    }
                })
                .catch(() => {
                    notiError('ไม่สามารถบันทึกได้')
                })
                .finally(() => loadDataStall())
        } else {
            const res = await StallsListApi.createZone(body)
                .then(res => {
                    if (res.status === 200) {
                        notiSuccess(t('บันทึกโซนสำเร็จ'))
                        dispatch(closeModal())
                    }
                })
                .catch(() => {
                    notiError('ไม่สามารถบันทึกได้')
                })
                .finally(() => loadDataStall())
        }


    }
    return (
        <>
            <HeaderCard text={t("จัดการโซน")} />
            <Box sx={{
                padding: "24px 48px",
                height: '100vh',
            }}>
                <Box>
                    <Grid container spacing={2}>
                        <Grid item lg={3} md={6} xs={12}>
                            <InputTextField label="ค้นหา" value={search}
                                onchange={(e: any) => setSearch(e.target.value)} />
                        </Grid>
                        <Grid item lg={9} md={6} xs={12}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'end' }}>
                                <div></div>
                                <ButtonCustom
                                    type="submit"
                                    textButton={'เพิ่ม'}
                                    onClick={() => {
                                        dispatch(showModal());
                                        setModalType('CREATE')
                                        setForm({})
                                    }}
                                    style={{ margin: '0px' }}
                                    btnStyle={{
                                        fontSize: "16px",
                                        width: "100%",
                                        padding: "0px",
                                        margin: '0px'
                                    }}
                                />
                            </div>
                        </Grid>

                    </Grid>
                </Box>
                <Box sx={{ marginTop: '24px', }}>
                    <TableCustom
                        headCells={headCells}
                        customScroll={true}
                        page={page}
                        pageLimit={pageLimit}
                        sortType={"ASC"}
                        sortBy=""
                        rowCount={rowCount}
                        rowsData={zoneData.map((d: any, i: any) => {
                            return renderData(d, i);
                        })}
                        onSort={() => { }}
                        setPageLimit={(value: number) => setPageLimit(value)}
                        setPage={(value: number) => setPage(value)}
                        tableMinWidth={1024}
                    />
                </Box>
            </Box>

            <ModalCustom
                title={
                    modalType === 'ADD' ? 'รายละเอียดเพิ่มโซน' : 'รายละเอียดโซน'
                }
                size="xl"
                onSubmit={() => {
                    handleSubmit()
                }}
                closeButton
                textBtnCancel={
                    'ยกเลิก'
                }
                textBtnConfirm={
                    'บันทึก'
                }

                component={
                    <>
                        <Grid container spacing={2}>

                            <Grid item xs={12} className="w-100">
                                <InputTextField
                                    key="name"
                                    value={form?.zoneName}
                                    onchange={(e) => {
                                        setForm({ ...form, zoneName: e.target.value })
                                        clearErrorMessage()
                                    }}
                                    required={true}
                                    helperText={errorMessage?.zoneName || ''}
                                    heading={t("ชื่อโซน")}
                                />
                            </Grid>
                            <Grid item xs={12} className="w-100">
                                <InputTextField
                                    key="name"
                                    value={form?.zoneNameEn}
                                    onchange={(e) => {
                                        setForm({ ...form, zoneNameEn: e.target.value })
                                        clearErrorMessage()
                                    }}
                                    // required={true}
                                    helperText={errorMessage?.zoneNameEn || ''}
                                    heading={t("ชื่อโซน (ภาษาอังกฤษ)")}
                                />
                            </Grid>

                            <Grid item xs={12} className="w-100">
                                <Typography sx={{ fontSize: "24px", fontWeight: '600', color: colors.themeMainColor }}>ขนาดโซน</Typography>
                            </Grid>
                            <Grid item md={6} xs={12} className="w-100">
                                <InputTextField
                                    key="name"
                                    value={form?.width}
                                    onchange={(e) => {
                                        setForm({ ...form, width: e.target.value })
                                        clearErrorMessage()
                                    }}
                                    required={true}
                                    helperText={errorMessage?.width || ''}
                                    heading={t("ความกว้าง (เมตร)")}
                                    onkeypress={handleTypingNumber}
                                />
                            </Grid>
                            <Grid item md={6} xs={12} className="w-100">
                                <InputTextField
                                    key="name"
                                    value={form?.height}
                                    onchange={(e) => {
                                        setForm({ ...form, height: e.target.value })
                                        clearErrorMessage()
                                    }}
                                    required={true}
                                    helperText={errorMessage?.height || ''}
                                    heading={t("ความยาว (เมตร)")}
                                    onkeypress={handleTypingNumber}
                                />
                            </Grid>
                            {/* <Grid item xs={12} className="w-100">
                                <Typography sx={{ fontSize: "24px", fontWeight: '600', color: colors.themeMainColor }}>จำนวนแผงค้า</Typography>
                            </Grid>
                            <Grid item md={6} xs={12} className="w-100">
                                <InputTextField
                                    key="name"
                                    value={form?.email}
                                    onchange={(e) => {
                                        setForm({ ...form, email: e.target.value })
                                        clearErrorMessage()
                                    }}
                                    required={true}
                                    helperText={errorMessage.email || ''}
                                    heading={t("แนวตั้ง")}
                                    onkeypress={handleTypingNumber}
                                />
                            </Grid>
                            <Grid item md={6} xs={12} className="w-100">
                                <InputTextField
                                    key="name"
                                    value={form?.email}
                                    onchange={(e) => {
                                        setForm({ ...form, email: e.target.value })
                                        clearErrorMessage()
                                    }}
                                    required={true}
                                    helperText={errorMessage.email || ''}
                                    heading={t("แนวนอน")}
                                    onkeypress={handleTypingNumber}
                                />
                            </Grid> */}
                            <Grid item xs={12} className="w-100">
                                <Typography sx={{ fontSize: "24px", fontWeight: '600', color: colors.themeMainColor }}>ขนาดแผงค้าตั้งต้น</Typography>
                            </Grid>
                            <Grid item md={6} xs={12} className="w-100">
                                <InputTextField
                                    key="name"
                                    value={form?.realWidth}
                                    onchange={(e) => {
                                        setForm({ ...form, realWidth: e.target.value })
                                        clearErrorMessage()
                                    }}
                                    required={true}
                                    helperText={errorMessage?.realWidth || ''}
                                    heading={t("ความกว้าง (เมตร)")}
                                    onkeypress={handleTypingNumber}
                                />
                            </Grid>
                            <Grid item md={6} xs={12} className="w-100">
                                <InputTextField
                                    key="name"
                                    value={form?.realHeight}
                                    onchange={(e) => {
                                        setForm({ ...form, realHeight: e.target.value })
                                        clearErrorMessage()
                                    }}
                                    required={true}
                                    helperText={errorMessage?.realHeight || ''}
                                    heading={t("ความยาว (เมตร)")}
                                    onkeypress={handleTypingNumber}
                                />
                            </Grid>
                        </Grid>
                    </>
                }
            />
        </>
    )
}
